<div class="sp-head sp-head--sm container px-0">
  <div class="mx-1 d-flex px-2 align-items-center">
    <div class="text-center mr-n3">
      <button
        class="sp-head__title sp-head__action-icon d-flex px-3 flex-nowrap"
        type="button"
        (click)="dataprocess()"
      >
        <i class="header_not fa-solid fa-refresh mx-2" style="margin-top: 5px;"></i>
        <p class="header_not d-inline text-nowrap m-0">Refrescar</p>
      </button>
    </div>
  </div>
</div>

<hr class="solid m-0">

<div class="sp-notification sp-scroll ps" data-scroll="true" style="overflow-y: auto; max-height: 440px;">
  <div class="container text-center py-3" *ngIf="!processdata?.length">
    No hay procesos disponibles
  </div>

  <div *ngFor="let item of processdata; let i = index" class="row justify-content-start">
    <div
      class="process-card col-12 col-md-10 d-flex flex-wrap align-items-start rounded p-3 mb-3 position-relative border shadow-sm"
      [ngClass]="getCardClass(item.cpR_ESTA)"
      style="margin-left: 10px;"
    >
      <!-- Íconos en esquina superior derecha -->
      <div class="position-absolute top-0 end-0 m-2 d-flex" style="    right: 1.8rem !important;
      margin-top: 0.5rem !important;">
        <i
          class="fa-solid fa-circle-info text-primary fs-5 me-2"
          style="cursor: pointer;color: #f4f4f4 !important;"
          (click)="open(mymodal, item.cadena, item.cpR_CONT, item.prO_CODI, item.tabla, getModalType(item.cpR_ESTA))"
          title="Información del proceso"
        ></i>
        <i
          *ngIf="item.cpR_ESTA === 'Verificado' || item.cpR_ESTA === 'Fallido'"
          class="fa-solid fa-xmark text-danger fs-5"
          style="cursor: pointer;color: #f4f4f4 !important;"
          (click)="itemClick(item.cadena)"
          title="Cerrar proceso"
        ></i>
      </div>

      <!-- Contenido principal -->
      <div class="d-flex flex-column flex-grow-1 mt-3 ms-1">
        <span class="fw-bold fs-6 mb-1">{{ item.cpR_CONT }} - {{ item.prO_CODI }}</span>
        <span class="fs-6 mb-1">{{ item.prO_NOMB }}</span>
        <span class="text-break mb-1">{{ item.cpR_MENS }}</span>
        <span class="fw-bold mb-1">Estado: {{ item.cpR_ESTA }}</span>
        <span class="mb-1">Fecha Inicio: {{ item.cpR_FINI }}</span>
        <span>Fecha Fin: {{ item.cpR_FFIN }}</span>
      </div>
    </div>
  </div>
</div>


<!-- Modal de ejemplo -->
<ng-template #mymodal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">{{body}}</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button>
    <button *ngIf="type == 'E'" class="btn btn-outline-dark" (click)="logReport()">Inconsistencias</button>
    <button *ngIf="type == 'I'" class="btn btn-outline-dark" (click)="logReport()">Resultados</button>
  </div>
</ng-template>
